import { configObject } from "src/awsconfig";
import { DRONESQUARE_BACKEND } from "src/domains/shared/constants/constants";
import { isReviewMode } from "./reviewMode";

/** 백엔드와의 계약 — 이 헤더를 실은 **관리자** 요청에만 검수 보류된 회차의 실제 상태가 온다. 값까지 계약이다. */
const HEADER_NAME = "X-Review-Mode";
const ON = "1";

/*
  검수 모드를 백엔드에 싣는 자리 — 들여오는 것만으로 선다(`review-mode`). 중앙 API 헬퍼(`amplifyCompat`)가 이 모듈을
  들여온다: 인증된 백엔드 요청을 만드는 모듈은 모두 그 헬퍼를 거치므로, 그 모듈들이 요청을 만들 수 있게 되기 전에 여기가
  평가돼 있다. 모드 자체는 `reviewMode` 가 이 모듈보다 먼저(이 모듈의 의존으로) 정한다.
*/
if (isReviewMode()) sendReviewModeToBackend();

/**
 * 백엔드로 가는 모든 요청에 검수 모드 헤더를 싣는다.
 *
 * 싣는 자리가 `fetch` 인 까닭: 백엔드로 가는 길이 셋(Amplify REST·`backendBaseUrl()` 직접 호출·SSE)이고 셋 다 여기를 지난다.
 * 호출부의 헤더 만들기는 20여 곳에 흩어져 있어, 한 곳에 실으려면 전송 계층뿐이다 — 새 호출부도 빠지지 않는다.
 * 검수 모드의 탭에서만 감싸므로 보통 탭의 전송은 손대지 않는다.
 *
 * 백엔드가 아닌 요청(S3·CloudFront·Cognito·SSM·같은 출처)은 그대로 보낸다 — 서명이 깨지고, 내부 헤더를 흘릴 이유도 없다.
 */
function sendReviewModeToBackend(): void {
  const backend = configObject[DRONESQUARE_BACKEND];
  if (!backend) return;
  const send = window.fetch.bind(window);
  window.fetch = (input, init) =>
    requestUrl(input).startsWith(backend)
      ? send(input, { ...init, headers: withReviewMode(input, init) })
      : send(input, init);
}

/** `fetch` 가 주소를 읽는 방식 그대로다 — `Request` 가 아니면 문자열로 바꿔 읽는다. */
function requestUrl(input: RequestInfo | URL): string {
  return input instanceof Request ? input.url : String(input);
}

function withReviewMode(input: RequestInfo | URL, init?: RequestInit): Headers {
  // `init.headers` 는 `Request` 의 헤더를 **대체**한다(fetch 규격) — 그것이 없을 때만 `Request` 의 헤더를 잇는다.
  const headers = new Headers(
    init?.headers ?? (input instanceof Request ? input.headers : undefined)
  );
  headers.set(HEADER_NAME, ON);
  return headers;
}
